<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<p class="immagine3"><span>Mieko Kawakami</span></p>
<p class="immagine4"><span>BREASTS AND EGGS</span></p>
<p class="immagine2" id="traduzione"><span><i>Translated from the Japanese<br/>
    by Sam Bett and David Boyd</i></span></p>
<div class="immagine"><img alt="" height="92" src="Images/logo.jpg" width="98"/></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Titlepage.vue?5bb9014d